/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import {
    Route,
    Routes
} from "react-router-dom"
import { Authenticator } from '@aws-amplify/ui-react';
import { Amplify } from "aws-amplify";
import Draw from './draw'
import Diagrams from './diagrams'
import { CamelotProvider } from './utils/camelotContext'
import Redirector from './redirector'
// import MindMapper from './mindmapper/App/index'
import MindmapWrapper from './mindmapperD3/index'
import ComponentBuilder from './componentbuilder/componentBuilder'
import Camelot from './utils/camelot'

const App = () => {

    const [drawn, setDrawn] = useState(false)
    const [grid, setGrid] = useState(false)
    const [saving, setSaving] = useState(false)
    const [readonly, setReadonly] = useState(false)
    const [modalvisible, setModalVisible] = useState(false)
    const [currentId, setCurrentId] = useState(null)
    const [currentName, setCurrentName] = useState('')
    const [currentDesc, setCurrentDesc] = useState('')
    const [drawing, setCurrentDrawing] = useState('')
    const [currentType, setCurrentType] = useState('')
    const [authenticated, setAuthenticated] = useState(false)
    const [currentColorScheme, setCurrentColorScheme] = useState(Camelot.DEFAULT_COLOR_SCHEME)

    useEffect(() => {
        onLoad();
    }, []);

    async function onLoad() {
        try {
            await Amplify.Authenticator.currentSession();
            setAuthenticated(true);
        }
        catch (e) {
            setAuthenticated(false);
        }
    }

    const CamelotFunctions = {
        hasDrawn: drawn,
        gridEnabled: grid,
        isSaving: saving,
        isReadOnly: readonly,
        isModalVisible: modalvisible,
        diagramId: currentId,
        diagramName: currentName,
        diagramDesc: currentDesc,
        drawing: drawing,
        diagramType: currentType,
        isAuthenticated: authenticated,
        colorScheme: currentColorScheme,
        setColorScheme: (val) => {
            setCurrentColorScheme(val)
        },
        setHasDrawn: (val) => {
            setDrawn(val)
        },
        setGridEnabled: (val) => {
            setGrid(val)
        },
        setIsSaving: (val) => {
            setSaving(val)
        },
        setIsReadOnly: (val) => {
            setReadonly(val)
        },
        showModal: () => {
            setModalVisible(true)
        },
        hideModal: () => {
            setModalVisible(false)
        },
        setDiagramId: (val) => {
            setCurrentId(val)
        },
        setDiagramName: (val) => {
            setCurrentName(val)
        },
        setDiagramDesc: (val) => {
            setCurrentDesc(val)
        },
        setDiagramDrawing: (val) => {
            setCurrentDrawing(val)
        },
        setDiagramType: (val) => {
            setCurrentType(val)
        },
        clearDiagram: () => {
            setCurrentId(null)
            setCurrentName('')
            setCurrentDesc('')
            setCurrentDrawing(null)
            setCurrentColorScheme(Camelot.DEFAULT_COLOR_SCHEME)
        },
        setDiagram: ({ id, name, desc, drawing = null, colorScheme = Camelot.DEFAULT_COLOR_SCHEME }) => {
            setCurrentId(id)
            setCurrentName(name)
            setCurrentDesc(desc)
            setCurrentDrawing(drawing)
            setCurrentColorScheme(colorScheme)
        },
        hasAuthenticated: (val) => {
            setAuthenticated(val)
        }
    }

    return (
        <Authenticator
            hideSignUp={true}
            loginMechanisms={['email']}
        >
            {({ signOut, user }) => (
                <CamelotProvider value={CamelotFunctions}>
                    <Routes>
                        <Route path="/" element={<Diagrams signOut={signOut} user={user} />} />
                        <Route path="/draw" element={<Draw />} />
                        <Route path="/draw/:id" element={<Redirector />} />
                        <Route path="/view/:id" element={<Draw readonly={true} />} />
                        <Route path="/maps/:id" element={<Redirector />} />
                        <Route path="/maps" element={<MindmapWrapper signOut={signOut} user={user} />} />
                        <Route path="/gen" element={<ComponentBuilder signOut={signOut} user={user} />} />
                    </Routes>
                </CamelotProvider >
            )}
        </Authenticator >
    )
}

export default App;
